import { render, staticRenderFns } from "./lolth-more-text-viewer.vue?vue&type=template&id=35f5d036&scoped=true&"
import script from "./lolth-more-text-viewer.vue?vue&type=script&lang=ts&"
export * from "./lolth-more-text-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./lolth-more-text-viewer.vue?vue&type=style&index=0&id=35f5d036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5d036",
  null
  
)

/* custom blocks */
import block0 from "./lolth-more-text-viewer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports